import { tv } from 'tailwind-variants'

import { defaultButtonCommonVariants } from './default-button-variants-common'

const defaultButtonWebVariants = tv({
  variants: {
    ...defaultButtonCommonVariants.variants,
    isDisabled: {
      true: 'opacity-disabled pointer-events-none',
    },
  },
  compoundVariants: [
    // Primary
    {
      variant: 'solid',
      colors: 'primary',
      class: `bg-gradient-to-r from-primary-gradient-inverse-from to-primary-gradient-inverse-to 
      hover:from-primary-gradient-inverse-high-from hover:to-primary-gradient-inverse-high-to`,
    },
  ],
})

export default defaultButtonWebVariants
